export default "__VITE_ASSET__61f0b870__"